/* eslint-disable import/no-unresolved */
/* eslint-disable import/order */
import React from 'react';
import Link from '../link';
import PropTypes from 'prop-types';
import { useLocation } from '@reach/router';

/* eslint-disable import/no-unresolved */
import { Pagination, Autoplay, EffectFade } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import ResImg from 'components/resImg';

import AspectImage from '../aspect-image/aspect-image';
import IconArrow from '../icons/icon-arrow';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';

const SwiperImages = ({ type, images }) => {
  const location = useLocation();
  const route = location.pathname.replace(/^\/|\/$/g, '');

  if (type === 'carousel') {
    return (
      <Swiper
        slidesPerView={1}
        modules={[Autoplay, EffectFade]}
        autoplay={{
          delay: 8000,
          pauseOnMouseEnter: false,
          disableOnInteraction: false,
        }}
        fadeEffect={{ crossFade: true }}
        effect="fade"
        speed="1500"
        loop
      >
        {images?.map((image, idx) => {
          const link = image.link?.cached_url;
          let linkTransform = `/${link}`;
          if (link.includes(`${route}`)) {
            linkTransform = link?.split('/')[1];
          }
          if (linkTransform.startsWith('//en-nz')) {
            linkTransform = linkTransform.replace('//en-nz', '');
          }

          return (
            <SwiperSlide key={idx} className="">
              <div className="h-mobile-fs xl:h-desktop-fs">
                <ResImg mobile={image.mobileImage} desktop={image.image} />
              </div>
              <div className="container py-7 lg:py-8 xl:py-10 ">
                <div className="grid gap-4 lg:grid-cols-2 lg:gap-8 xl:gap-10">
                  {image.title && (
                    <div className=" flex items-center justify-between lg:col-span-2">
                      <h2 className="pt-7 font-heading text-sm uppercase lg:pt-8 lg:text-xl xl:pt-10 xl:text-2.5xl">
                        {image.title}
                      </h2>
                      {link && (
                        <Link
                          to={linkTransform}
                          className='group relative flex items-center after:absolute after:inset-0 after:content-[""]'
                        >
                          <span className="sr-only">{image.title}</span>
                          <span className="w-4 translate-x-0 transition-all duration-200 group-hover:translate-x-[0.15rem] lg:w-auto">
                            <IconArrow className="w-full lg:w-auto" />
                          </span>
                        </Link>
                      )}
                    </div>
                  )}
                  {image.text && (
                    <p className="mt-2 text-lg !leading-normal lg:text-2xl lg:!leading-[1.25] xl:max-w-[70%] xl:text-3.5xl">
                      {image.text}
                    </p>
                  )}
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    );
  }

  return (
    <Swiper
      slidesPerView={1}
      modules={[Pagination]}
      pagination={{
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 4,
      }}
      className="swiper-container"
      loop
    >
      {images?.map((image, idx) => (
        <SwiperSlide key={idx}>
          <div className="container mt-5 box-border lg:mt-0 lg:p-8 lg:pb-0 xl:p-16">
            <AspectImage
              imgSrc={image.imgSrc}
              smallImgSrc={image.smallImgSrc ? image.smallImgSrc : image.imgSrc}
              title={image.title}
            />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

SwiperImages.propTypes = {
  type: PropTypes.oneOf(['carousel', 'gallery']),
  images: PropTypes.arrayOf(
    PropTypes.shape({
      imgSrc: PropTypes.string,
      smallImgSrc: PropTypes.string,
      title: PropTypes.string,
      text: PropTypes.string,
      link: PropTypes.object,
      id: PropTypes.number,
    })
  ).isRequired,
};

SwiperImages.defaultProps = {
  type: 'gallery',
};

export default SwiperImages;
